import { MartProductState } from './martProduct-reducer';
import { CallMartProductTncAction, MART_PRODUCT_ACTION_TYPE, MartProductActions } from './martProduct-type';

export const martProductCreators = {
  setMartProductState: <KeyName extends keyof MartProductState>(key: KeyName, value: MartProductState[KeyName])
    : MartProductActions => ({
      type: MART_PRODUCT_ACTION_TYPE.SET_MART_PRODUCT_STATE,
      payload: { key, value }
    }),
  callMartProductTnc: (data: any, isCallTnc: boolean): CallMartProductTncAction => ({
    type: MART_PRODUCT_ACTION_TYPE.CALL_MART_PRODUCT_TNC,
    payload: { data, isCallTnc }
  })
};
